import { RoleEnum } from "@ang/shared-types";

export class User {
	private username: string;
	private role: RoleEnum;
	private card_code: string;
	private profit_code: string;

	//Singleton
	private static instance: User;

	constructor() {
		if (User.instance) {
			throw new Error(
				"Use User.getInstance() to get the single instance of this class.",
			);
		}

		this.setDataFromToken(sessionStorage.getItem("jwt") || "");
	}

	public static getInstance(): User {
		if (!User.instance) {
			User.instance = new User();
		}
		return User.instance;
	}

	public getUsername(): string {
		return this.username;
	}
	public getRole(): RoleEnum {
		return this.role;
	}
	public getCardCode(): string {
		return this.card_code;
	}
	public getProfitCenter(): string {
		return this.profit_code;
	}

	private setDataFromToken(token: string): void {
		try {
			if (token !== "") {
				const payload = JSON.parse(atob(token.split(".")[1]));
				this.username = payload.username;
				this.role = payload.role;
				this.card_code = payload.card_code;
				this.profit_code = payload.profit_code;
			} else {
				this.username = "";
				this.role = RoleEnum.USER;
				this.card_code = "";
				this.profit_code = "";
			}
		} catch (error) {
			console.error("Failed to parse token:", error);
		}
	}

	public static clearData(): void {
		User.instance = undefined;
	}
}
